"use strict";
(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[989],{

/***/ 22974:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "A": function() { return /* binding */ TextButton; }
/* harmony export */ });
/* harmony import */ var _swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(26042);
/* harmony import */ var _swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(69396);
/* harmony import */ var _swc_helpers_src_object_without_properties_mjs__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(99534);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(67294);
/* harmony import */ var baseui_button__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(53674);
/* harmony import */ var _hooks_use_overrides__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(58817);
/* harmony import */ var polished__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(43281);
/* harmony import */ var _icon__WEBPACK_IMPORTED_MODULE_11__ = __webpack_require__(32079);
/* harmony import */ var _styles_typography__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(67246);
/* harmony import */ var _styles_colors__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(32317);
/* harmony import */ var _hooks_use_space__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(16333);












var TextButton = /*#__PURE__*/ (0,react__WEBPACK_IMPORTED_MODULE_1__.forwardRef)(function(_param, ref) {
    var children = _param.children, overrides = _param.overrides, leading = _param.leading, trailing = _param.trailing, spaceTop = _param.spaceTop, spaceBottom = _param.spaceBottom, _color = _param.color, color = _color === void 0 ? _styles_colors__WEBPACK_IMPORTED_MODULE_2__/* .colors.gray600 */ .O.gray600 : _color, props = (0,_swc_helpers_src_object_without_properties_mjs__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)(_param, [
        "children",
        "overrides",
        "leading",
        "trailing",
        "spaceTop",
        "spaceBottom",
        "color"
    ]);
    var disabledColor = _styles_colors__WEBPACK_IMPORTED_MODULE_2__/* .colors.gray300 */ .O.gray300;
    var backgroundColor = "transparent";
    var _$ref = (0,_hooks_use_space__WEBPACK_IMPORTED_MODULE_4__/* .useSpace */ .$)({
        spaceTop: spaceTop,
        spaceBottom: spaceBottom
    }), marginTop = _$ref.marginTop, marginBottom = _$ref.marginBottom;
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(baseui_button__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z, (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .Z)({
        overrides: (0,_hooks_use_overrides__WEBPACK_IMPORTED_MODULE_8__/* .useOverrides */ .Q)({
            BaseButton: {
                style: (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .Z)({
                    color: color,
                    backgroundColor: backgroundColor
                }, marginTop, marginBottom, _styles_typography__WEBPACK_IMPORTED_MODULE_9__/* .typography.LabelS */ .c.LabelS), {
                    boxSizing: "border-box",
                    fontWeight: 400,
                    display: "inline-flex",
                    alignSelf: "center",
                    alignItems: "center",
                    justifyContent: "center",
                    position: "relative",
                    userSelect: "none",
                    whiteSpace: "pre"
                }), (0,polished__WEBPACK_IMPORTED_MODULE_10__/* .padding */ .o3)("0px")), {
                    ":active": {
                        backgroundColor: backgroundColor
                    },
                    ":hover": {
                        color: color,
                        backgroundColor: backgroundColor
                    },
                    ":disabled": {
                        color: disabledColor,
                        backgroundColor: backgroundColor,
                        ":hover": {
                            textShadow: "none",
                            color: disabledColor,
                            backgroundColor: backgroundColor
                        }
                    },
                    ":after": {
                        content: '""',
                        position: "absolute",
                        bottom: "-1px",
                        left: trailing && "0px",
                        right: leading && "0px",
                        width: leading || trailing ? "calc(100% - 16px)" : "100%",
                        height: "1px",
                        backgroundColor: color
                    }
                })
            },
            StartEnhancer: {
                style: {
                    marginRight: "4px"
                }
            },
            EndEnhancer: {
                style: {
                    marginLeft: "4px"
                }
            }
        }, overrides),
        startEnhancer: leading && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_icon__WEBPACK_IMPORTED_MODULE_11__/* .Icon */ .J, {
            type: leading,
            color: props.disabled ? disabledColor : color,
            size: 12
        }),
        endEnhancer: trailing && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_icon__WEBPACK_IMPORTED_MODULE_11__/* .Icon */ .J, {
            type: trailing,
            color: props.disabled ? disabledColor : color,
            size: 12
        })
    }, props), {
        ref: ref,
        children: children
    }));
});


/***/ }),

/***/ 49774:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "r": function() { return /* binding */ EmptyList; }
/* harmony export */ });
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var _components_base_typography__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(67408);
/* harmony import */ var _components_base_button_text_button__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(22974);
/* harmony import */ var _styles_colors__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(32317);
/* harmony import */ var _components_base_block__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(94306);





var EmptyList = function(param) {
    var leading = param.leading, trailing = param.trailing, onClick = param.onClick, title = param.title, buttonLabel = param.buttonLabel, isFilterSelected = param.isFilterSelected, backgoundColor = param.backgoundColor, _padding = param.padding, padding = _padding === void 0 ? "120px" : _padding;
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(_components_base_block__WEBPACK_IMPORTED_MODULE_1__/* .BaseBlock */ .v, {
        flexbox: true,
        flexCenter: true,
        column: true,
        paddingTop: padding,
        paddingBottom: padding,
        width: "100%",
        backgroundColor: backgoundColor,
        rounded: 16,
        children: [
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_components_base_typography__WEBPACK_IMPORTED_MODULE_2__/* .LabelM */ .i_, {
                color: _styles_colors__WEBPACK_IMPORTED_MODULE_3__/* .colors.gray500 */ .O.gray500,
                children: title
            }),
            isFilterSelected && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_components_base_button_text_button__WEBPACK_IMPORTED_MODULE_4__/* .TextButton */ .A, {
                onClick: onClick,
                color: _styles_colors__WEBPACK_IMPORTED_MODULE_3__/* .colors.blue400 */ .O.blue400,
                leading: leading,
                trailing: trailing,
                spaceTop: 12,
                children: buttonLabel
            })
        ]
    });
};


/***/ }),

/***/ 99407:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {


// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "i": function() { return /* binding */ BasicLayout; }
});

// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_sliced_to_array.mjs + 2 modules
var src_sliced_to_array = __webpack_require__(828);
// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./node_modules/next/head.js
var head = __webpack_require__(9008);
var head_default = /*#__PURE__*/__webpack_require__.n(head);
// EXTERNAL MODULE: ./node_modules/lodash/merge.js
var merge = __webpack_require__(82492);
var merge_default = /*#__PURE__*/__webpack_require__.n(merge);
// EXTERNAL MODULE: ./node_modules/styletron-react/dist-browser-esm/index.js
var dist_browser_esm = __webpack_require__(54511);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_spread.mjs
var _object_spread = __webpack_require__(26042);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_throw.mjs
var _throw = __webpack_require__(51351);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_to_consumable_array.mjs + 2 modules
var _to_consumable_array = __webpack_require__(29815);
// EXTERNAL MODULE: ./styles/constants.ts
var constants = __webpack_require__(45875);
// EXTERNAL MODULE: ./node_modules/next/link.js
var next_link = __webpack_require__(41664);
var link_default = /*#__PURE__*/__webpack_require__.n(next_link);
// EXTERNAL MODULE: ./styles/colors.ts
var styles_colors = __webpack_require__(32317);
// EXTERNAL MODULE: ./components/base-button/base-button.tsx + 1 modules
var base_button = __webpack_require__(11485);
// EXTERNAL MODULE: ./modules/users/hooks/use-me.tsx
var use_me = __webpack_require__(17243);
// EXTERNAL MODULE: ./node_modules/baseui/esm/flex-grid/flex-grid.js + 1 modules
var flex_grid = __webpack_require__(46322);
// EXTERNAL MODULE: ./node_modules/baseui/esm/flex-grid/flex-grid-item.js
var flex_grid_item = __webpack_require__(11524);
// EXTERNAL MODULE: ./components/logo/logo.tsx + 1 modules
var logo = __webpack_require__(49965);
// EXTERNAL MODULE: ./components/header/header-menu.tsx
var header_menu = __webpack_require__(97006);
// EXTERNAL MODULE: ./styles/box-shadow.ts
var box_shadow = __webpack_require__(24035);
// EXTERNAL MODULE: ./components/base-grid/base-grid.tsx
var base_grid = __webpack_require__(83825);
// EXTERNAL MODULE: ./components/base-cell/base-cell.tsx
var base_cell = __webpack_require__(84525);
// EXTERNAL MODULE: ./styles/z-indexes.ts
var z_indexes = __webpack_require__(9227);
// EXTERNAL MODULE: ./lib/routes.ts
var routes = __webpack_require__(78954);
// EXTERNAL MODULE: ./lib/hooks/use-scroll-point.tsx
var use_scroll_point = __webpack_require__(51774);
// EXTERNAL MODULE: ./components/base-block/base-block.tsx
var base_block = __webpack_require__(94306);
// EXTERNAL MODULE: ./components/header/drawer.tsx
var drawer = __webpack_require__(95587);
// EXTERNAL MODULE: ./lib/graphql/documents.generated.ts
var documents_generated = __webpack_require__(60369);
;// CONCATENATED MODULE: ./components/header/header.tsx
























var Header = function(param) {
    var param = param !== null ? param : (0,_throw/* default */.Z)(new TypeError("Cannot destructure undefined"));
    var ref = (0,src_sliced_to_array/* default */.Z)((0,dist_browser_esm/* useStyletron */.hQ)(), 1), css = ref[0];
    var ref1 = (0,use_me/* useMe */.P)(), me = ref1.me, loading = ref1.loading;
    var isLoggedIn = Boolean(me);
    var isPoint = (0,use_scroll_point/* useScrollPoint */.A)().isPoint;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("header", {
        className: css((0,_object_spread/* default */.Z)({
            position: "fixed",
            top: 0,
            width: "100%",
            boxSizing: "border-box",
            backgroundColor: styles_colors/* colors.white */.O.white,
            zIndex: z_indexes/* zIndexes.header */.U.header
        }, isPoint && (0,box_shadow/* boxShadow */.W)("borderBottom"))),
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(base_grid/* BaseGrid */.w, {
            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(base_cell/* BaseCell */.q, {
                span: [
                    4,
                    8,
                    12
                ],
                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(flex_grid/* default */.Z, {
                    className: css({
                        height: constants/* HEADER_HEIGHT */.M + "px",
                        display: "flex",
                        alignItems: "center"
                    }),
                    gridColumnGap: "32px",
                    flexGridColumnCount: 3,
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(flex_grid_item/* default */.ZP, {
                            className: css({
                                flex: "1 1 0"
                            }),
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(logo/* Logo */.T, {
                                size: "s",
                                active: true
                            })
                        }, "logo"),
                        !loading && /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(flex_grid_item/* default */.ZP, {
                                    display: [
                                        "none",
                                        "none",
                                        "block",
                                        "block"
                                    ],
                                    className: css({
                                        flex: "1 1 auto"
                                    })
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(flex_grid_item/* default */.ZP, {
                                    className: css({
                                        flex: "1 1 0",
                                        display: "flex",
                                        justifyContent: "flex-end"
                                    }),
                                    children: !loading && isLoggedIn ? /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
                                        children: [
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(drawer/* BaseDrawer */.L, {}),
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(header_menu/* HeaderMenu */.y, {
                                                menus: (0,_to_consumable_array/* default */.Z)(me && (me === null || me === void 0 ? void 0 : me.role) !== documents_generated/* UserRole.Patient */.i4.Patient && [
                                                    {
                                                        name: "해석 참여하기",
                                                        icon: "ChevronRight",
                                                        href: routes/* Routes.DOCTOR_HOME */.Z.DOCTOR_HOME,
                                                        onClick: undefined,
                                                        color: undefined
                                                    }, 
                                                ] || []).concat([
                                                    {
                                                        name: "설정",
                                                        icon: undefined,
                                                        href: routes/* Routes.SETTINGS_ACCOUNT */.Z.SETTINGS_ACCOUNT,
                                                        onClick: undefined,
                                                        color: undefined
                                                    }, 
                                                ])
                                            })
                                        ]
                                    }) : /*#__PURE__*/ (0,jsx_runtime.jsxs)(base_block/* BaseBlock */.v, {
                                        flexbox: true,
                                        columnGap: "16px",
                                        children: [
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)((link_default()), {
                                                href: routes/* Routes.AUTH_LOGIN */.Z.AUTH_LOGIN,
                                                passHref: true,
                                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(base_button/* BaseButton */.Y, {
                                                    $type: "secondary",
                                                    $size: "m",
                                                    children: "로그인"
                                                })
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)((link_default()), {
                                                href: routes/* Routes.AUTH_LOGIN */.Z.AUTH_LOGIN,
                                                passHref: true,
                                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(base_button/* BaseButton */.Y, {
                                                    $size: "m",
                                                    children: "회원가입"
                                                })
                                            })
                                        ]
                                    })
                                })
                            ]
                        })
                    ]
                })
            })
        })
    });
};
var NavItem = function(param) {
    var href = param.href, label = param.label, selected = param.selected;
    var ref = _sliced_to_array(useStyletron(), 1), css = ref[0];
    return /*#__PURE__*/ _jsx(Link, {
        href: href,
        passHref: true,
        children: /*#__PURE__*/ _jsx(LabelS, {
            as: "a",
            weight: 500,
            color: selected ? colors.black : colors.gray500,
            children: label
        })
    });
};

// EXTERNAL MODULE: ./components/footer/footer.tsx + 2 modules
var footer = __webpack_require__(5516);
;// CONCATENATED MODULE: ./components/layouts/basic-layout.tsx








var BasicLayout = function(param) {
    var children = param.children, overrides = param.overrides, helmetTitle = param.helmetTitle;
    var ref;
    var ref1 = (0,src_sliced_to_array/* default */.Z)((0,dist_browser_esm/* useStyletron */.hQ)(), 1), css = ref1[0];
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
        children: [
            helmetTitle && /*#__PURE__*/ (0,jsx_runtime.jsx)((head_default()), {
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("title", {
                    children: helmetTitle
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: css({
                    display: "flex",
                    flexDirection: "column",
                    minHeight: "100vh",
                    overflow: "hidden"
                }),
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Header, {}),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("main", {
                        className: css(merge_default()({
                            flex: "1 1 auto",
                            overflowY: "hidden",
                            overflowX: "hidden",
                            position: "relative",
                            marginTop: constants/* HEADER_HEIGHT */.M + "px"
                        }, (overrides === null || overrides === void 0 ? void 0 : (ref = overrides.main) === null || ref === void 0 ? void 0 : ref.style) || {})),
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                            children: children
                        })
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(footer/* Footer */.$, {})
                ]
            })
        ]
    });
};


/***/ }),

/***/ 29339:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "d": function() { return /* binding */ SettingsLayout; }
/* harmony export */ });
/* harmony import */ var _swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_12__ = __webpack_require__(26042);
/* harmony import */ var _swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_11__ = __webpack_require__(69396);
/* harmony import */ var _swc_helpers_src_sliced_to_array_mjs__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(828);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var _components_layouts_basic_layout__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(99407);
/* harmony import */ var _components_base_block__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(94306);
/* harmony import */ var _components_base_cell__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(84525);
/* harmony import */ var _components_base_grid__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(83825);
/* harmony import */ var _components_base_typography__WEBPACK_IMPORTED_MODULE_16__ = __webpack_require__(53321);
/* harmony import */ var _lib_routes__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(78954);
/* harmony import */ var _modules_auth_hooks_use_logout__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(84322);
/* harmony import */ var _styles_colors__WEBPACK_IMPORTED_MODULE_14__ = __webpack_require__(32317);
/* harmony import */ var _styles_utils__WEBPACK_IMPORTED_MODULE_13__ = __webpack_require__(45500);
/* harmony import */ var next_link__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(41664);
/* harmony import */ var next_link__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(next_link__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var next_router__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(11163);
/* harmony import */ var next_router__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(next_router__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var polished__WEBPACK_IMPORTED_MODULE_17__ = __webpack_require__(43281);
/* harmony import */ var styletron_react__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(54511);
/* harmony import */ var _components_icon__WEBPACK_IMPORTED_MODULE_15__ = __webpack_require__(32079);


















var SettingsLayout = function(param) {
    var children = param.children, helmetTitle = param.helmetTitle;
    var ref = (0,_swc_helpers_src_sliced_to_array_mjs__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)((0,styletron_react__WEBPACK_IMPORTED_MODULE_4__/* .useStyletron */ .hQ)(), 1), css = ref[0];
    var router = (0,next_router__WEBPACK_IMPORTED_MODULE_2__.useRouter)();
    var logout = (0,_modules_auth_hooks_use_logout__WEBPACK_IMPORTED_MODULE_5__/* .useLogout */ .a)().logout;
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(_components_layouts_basic_layout__WEBPACK_IMPORTED_MODULE_6__/* .BasicLayout */ .i, {
        helmetTitle: helmetTitle,
        children: [
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_components_base_grid__WEBPACK_IMPORTED_MODULE_7__/* .BaseGrid */ .w, {
                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_components_base_cell__WEBPACK_IMPORTED_MODULE_8__/* .BaseCell */ .q, {
                    spaceTop: 48,
                    span: [
                        0,
                        2,
                        3
                    ],
                    style: {
                        position: "relative"
                    },
                    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(_components_base_block__WEBPACK_IMPORTED_MODULE_9__/* .BaseBlock */ .v, {
                        className: css({
                            display: "flex",
                            flexDirection: "column",
                            position: "absolute",
                            width: "calc(100% - 48px)"
                        }),
                        children: [
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(_components_base_block__WEBPACK_IMPORTED_MODULE_9__/* .BaseBlock */ .v, {
                                flexbox: true,
                                alignCenter: true,
                                columnGap: "4px",
                                marginBottom: "16px",
                                cursor: "pointer",
                                onClick: function() {
                                    router.push(_lib_routes__WEBPACK_IMPORTED_MODULE_10__/* .Routes.PATIENT_HOME */ .Z.PATIENT_HOME);
                                },
                                paddingTop: "8px",
                                paddingBottom: "8px",
                                rounded: 8,
                                className: css((0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_11__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_12__/* ["default"] */ .Z)({}, (0,_styles_utils__WEBPACK_IMPORTED_MODULE_13__/* .transition */ .eR)()), {
                                    ":hover": {
                                        backgroundColor: _styles_colors__WEBPACK_IMPORTED_MODULE_14__/* .colors.gray50 */ .O.gray50
                                    }
                                })),
                                children: [
                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_components_icon__WEBPACK_IMPORTED_MODULE_15__/* .Icon */ .J, {
                                        type: "ChevronLeft",
                                        size: 20
                                    }),
                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_components_base_typography__WEBPACK_IMPORTED_MODULE_16__/* .HeadingS */ .HR, {
                                        children: "설정"
                                    })
                                ]
                            }),
                            [
                                {
                                    id: 1,
                                    href: _lib_routes__WEBPACK_IMPORTED_MODULE_10__/* .Routes.SETTINGS_ACCOUNT */ .Z.SETTINGS_ACCOUNT,
                                    label: "계정 관리"
                                },
                                {
                                    id: 2,
                                    href: _lib_routes__WEBPACK_IMPORTED_MODULE_10__/* .Routes.SETTINGS_NOTIFICATIONS */ .Z.SETTINGS_NOTIFICATIONS,
                                    label: "알림 설정"
                                },
                                {
                                    id: 3,
                                    href: _lib_routes__WEBPACK_IMPORTED_MODULE_10__/* .Routes.SETTINGS_INQUIRIES */ .Z.SETTINGS_INQUIRIES,
                                    label: "문의 내역"
                                }, 
                            ].map(function(param) {
                                var id = param.id, href = param.href, label = param.label;
                                return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)((next_link__WEBPACK_IMPORTED_MODULE_1___default()), {
                                    href: href,
                                    passHref: true,
                                    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("a", {
                                        className: css((0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_11__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_12__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_11__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_12__/* ["default"] */ .Z)({}, (0,polished__WEBPACK_IMPORTED_MODULE_17__/* .padding */ .o3)("12px"), (0,_styles_utils__WEBPACK_IMPORTED_MODULE_13__/* .borderRadius */ .E0)(8)), {
                                            backgroundColor: router.pathname.includes(href) ? _styles_colors__WEBPACK_IMPORTED_MODULE_14__/* .colors.blue50 */ .O.blue50 : _styles_colors__WEBPACK_IMPORTED_MODULE_14__/* .colors.white */ .O.white
                                        }), (0,_styles_utils__WEBPACK_IMPORTED_MODULE_13__/* .transition */ .eR)()), {
                                            ":hover": {
                                                backgroundColor: _styles_colors__WEBPACK_IMPORTED_MODULE_14__/* .colors.gray50 */ .O.gray50
                                            }
                                        })),
                                        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_components_base_typography__WEBPACK_IMPORTED_MODULE_16__/* .HeadingXS */ .Kz, {
                                            weight: 400,
                                            color: router.pathname.includes(href) ? _styles_colors__WEBPACK_IMPORTED_MODULE_14__/* .colors.blue400 */ .O.blue400 : _styles_colors__WEBPACK_IMPORTED_MODULE_14__/* .colors.gray700 */ .O.gray700,
                                            children: label
                                        })
                                    })
                                }, id);
                            })
                        ]
                    })
                })
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(_components_base_grid__WEBPACK_IMPORTED_MODULE_7__/* .BaseGrid */ .w, {
                children: [
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_components_base_cell__WEBPACK_IMPORTED_MODULE_8__/* .BaseCell */ .q, {
                        span: [
                            0,
                            2,
                            2
                        ]
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(_components_base_cell__WEBPACK_IMPORTED_MODULE_8__/* .BaseCell */ .q, {
                        skip: [
                            0,
                            0,
                            1
                        ],
                        span: [
                            4,
                            6,
                            9
                        ],
                        children: [
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_components_base_typography__WEBPACK_IMPORTED_MODULE_16__/* .HeadingS */ .HR, {
                                marginBottom: "32px",
                                children: helmetTitle
                            }),
                            children
                        ]
                    })
                ]
            })
        ]
    });
};


/***/ }),

/***/ 34582:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "t": function() { return /* binding */ Pagination; }
/* harmony export */ });
/* harmony import */ var _swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_14__ = __webpack_require__(14924);
/* harmony import */ var _swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(26042);
/* harmony import */ var _swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(69396);
/* harmony import */ var _swc_helpers_src_sliced_to_array_mjs__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(828);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var _components_hooks_use_space__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(16333);
/* harmony import */ var _styles_colors__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(32317);
/* harmony import */ var _styles_typography__WEBPACK_IMPORTED_MODULE_12__ = __webpack_require__(67246);
/* harmony import */ var _styles_utils__WEBPACK_IMPORTED_MODULE_13__ = __webpack_require__(45500);
/* harmony import */ var classnames__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(93967);
/* harmony import */ var classnames__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(classnames__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var lodash_range__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(96026);
/* harmony import */ var lodash_range__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(lodash_range__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var polished__WEBPACK_IMPORTED_MODULE_11__ = __webpack_require__(43281);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(67294);
/* harmony import */ var styletron_react__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(54511);
/* harmony import */ var _icon__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(32079);















var Pagination = /*#__PURE__*/ react__WEBPACK_IMPORTED_MODULE_3__.memo(function(param) {
    var numPages = param.numPages, currentPage = param.currentPage, onNextClick = param.onNextClick, onPrevClick = param.onPrevClick, onPageChange = param.onPageChange, className = param.className, _spaceTop = param.spaceTop, spaceTop = _spaceTop === void 0 ? 48 : _spaceTop, spaceBottom = param.spaceBottom;
    var ref = (0,_swc_helpers_src_sliced_to_array_mjs__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)((0,styletron_react__WEBPACK_IMPORTED_MODULE_5__/* .useStyletron */ .hQ)(), 1), css = ref[0];
    var ref1 = (0,_components_hooks_use_space__WEBPACK_IMPORTED_MODULE_6__/* .useSpace */ .$)({
        spaceTop: spaceTop,
        spaceBottom: spaceBottom
    }), marginTop = ref1.marginTop, marginBottom = ref1.marginBottom;
    var paginationNumbers = (0,react__WEBPACK_IMPORTED_MODULE_3__.useMemo)(function() {
        var pageNumbers = Math.floor((currentPage - 1) / 5) * 5 + 1;
        return lodash_range__WEBPACK_IMPORTED_MODULE_2___default()(pageNumbers, pageNumbers + 5).filter(function(num) {
            return num < numPages + 1;
        });
    }, [
        currentPage,
        numPages
    ]);
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.Fragment, {
        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
            className: classnames__WEBPACK_IMPORTED_MODULE_1___default()("pagination", className, css((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .Z)({
                display: "flex",
                justifyContent: "center",
                gap: "8px"
            }, marginTop, marginBottom))),
            children: [
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(Box, {
                    onClick: onPrevClick,
                    disabled: currentPage === 1,
                    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_icon__WEBPACK_IMPORTED_MODULE_8__/* .Icon */ .J, {
                        type: "ChevronLeft",
                        size: 12,
                        color: currentPage === numPages ? _styles_colors__WEBPACK_IMPORTED_MODULE_9__/* .colors.gray400 */ .O.gray400 : _styles_colors__WEBPACK_IMPORTED_MODULE_9__/* .colors.gray700 */ .O.gray700
                    })
                }),
                paginationNumbers.map(function(i) {
                    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(Box, {
                        selected: i === currentPage,
                        onClick: onPageChange && function() {
                            return onPageChange({
                                nextPage: i,
                                prevPage: i
                            });
                        },
                        children: i
                    }, i);
                }),
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(Box, {
                    onClick: onNextClick,
                    disabled: numPages === 0,
                    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_icon__WEBPACK_IMPORTED_MODULE_8__/* .Icon */ .J, {
                        type: "ChevronRight",
                        size: 12,
                        color: currentPage === numPages ? _styles_colors__WEBPACK_IMPORTED_MODULE_9__/* .colors.gray400 */ .O.gray400 : _styles_colors__WEBPACK_IMPORTED_MODULE_9__/* .colors.gray700 */ .O.gray700
                    })
                })
            ]
        })
    });
});
var Box = function(param) {
    var children = param.children, selected = param.selected, onClick = param.onClick, disabled = param.disabled;
    var ref = (0,_swc_helpers_src_sliced_to_array_mjs__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)((0,styletron_react__WEBPACK_IMPORTED_MODULE_5__/* .useStyletron */ .hQ)(), 1), css = ref[0];
    var _obj;
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("button", {
        onClick: onClick,
        disabled: disabled,
        className: css((0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_10__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_10__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_10__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .Z)({
            backgroundColor: selected ? _styles_colors__WEBPACK_IMPORTED_MODULE_9__/* .colors.blue50 */ .O.blue50 : _styles_colors__WEBPACK_IMPORTED_MODULE_9__/* .colors.white */ .O.white,
            cursor: "pointer",
            width: "32px",
            height: "32px"
        }, (0,polished__WEBPACK_IMPORTED_MODULE_11__/* .borderRadius */ .E0)("top", "8px"), (0,polished__WEBPACK_IMPORTED_MODULE_11__/* .borderRadius */ .E0)("bottom", "8px"), (0,polished__WEBPACK_IMPORTED_MODULE_11__/* .borderWidth */ .J4)("1px"), (0,polished__WEBPACK_IMPORTED_MODULE_11__/* .borderStyle */ .$u)("none"), (0,polished__WEBPACK_IMPORTED_MODULE_11__/* .borderWidth */ .J4)("1px"), (0,polished__WEBPACK_IMPORTED_MODULE_11__/* .borderColor */ .tv)(selected ? _styles_colors__WEBPACK_IMPORTED_MODULE_9__/* .colors.blue400 */ .O.blue400 : _styles_colors__WEBPACK_IMPORTED_MODULE_9__/* .colors.gray100 */ .O.gray100)), {
            display: "flex",
            justifyContent: "center",
            alignItems: "center"
        }), _styles_typography__WEBPACK_IMPORTED_MODULE_12__/* .typography.ParagraphM */ .c.ParagraphM), {
            color: selected ? _styles_colors__WEBPACK_IMPORTED_MODULE_9__/* .colors.blue400 */ .O.blue400 : _styles_colors__WEBPACK_IMPORTED_MODULE_9__/* .colors.gray700 */ .O.gray700
        }), (0,_styles_utils__WEBPACK_IMPORTED_MODULE_13__/* .transition */ .eR)()), (_obj = {}, (0,_swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_14__/* ["default"] */ .Z)(_obj, ":disabled", {
            color: _styles_colors__WEBPACK_IMPORTED_MODULE_9__/* .colors.gray400 */ .O.gray400,
            cursor: "not-allowed",
            ":hover": {
                backgroundColor: _styles_colors__WEBPACK_IMPORTED_MODULE_9__/* .colors.white */ .O.white
            }
        }), (0,_swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_14__/* ["default"] */ .Z)(_obj, ":hover", {
            backgroundColor: selected ? _styles_colors__WEBPACK_IMPORTED_MODULE_9__/* .colors.blue50 */ .O.blue50 : _styles_colors__WEBPACK_IMPORTED_MODULE_9__/* .colors.gray50 */ .O.gray50
        }), _obj))),
        children: children
    });
};


/***/ }),

/***/ 92352:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "O": function() { return /* binding */ InquiryStatusTag; }
/* harmony export */ });
/* harmony import */ var _swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(26042);
/* harmony import */ var _swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(69396);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var _styles_colors__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(32317);
/* harmony import */ var _styles_utils__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(45500);
/* harmony import */ var polished__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(43281);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(67294);
/* harmony import */ var _base_typography__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(67408);








var InquiryStatusTag = /*#__PURE__*/ react__WEBPACK_IMPORTED_MODULE_1__.memo(function(param) {
    var isAnswered = param.isAnswered, isAdmin = param.isAdmin;
    var ref = (0,react__WEBPACK_IMPORTED_MODULE_1__.useMemo)(function() {
        return isAnswered ? {
            label: "답변완료",
            color: _styles_colors__WEBPACK_IMPORTED_MODULE_2__/* .colors.green400 */ .O.green400,
            backgroundColor: _styles_colors__WEBPACK_IMPORTED_MODULE_2__/* .colors.green50 */ .O.green50
        } : isAdmin ? {
            label: "답변대기",
            color: _styles_colors__WEBPACK_IMPORTED_MODULE_2__/* .colors.orange400 */ .O.orange400,
            backgroundColor: _styles_colors__WEBPACK_IMPORTED_MODULE_2__/* .colors.orange50 */ .O.orange50
        } : {
            label: "처리중",
            color: _styles_colors__WEBPACK_IMPORTED_MODULE_2__/* .colors.orange400 */ .O.orange400,
            backgroundColor: _styles_colors__WEBPACK_IMPORTED_MODULE_2__/* .colors.yellow100 */ .O.yellow100
        };
    }, [
        isAdmin,
        isAnswered
    ]), label = ref.label, color = ref.color, backgroundColor = ref.backgroundColor;
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_base_typography__WEBPACK_IMPORTED_MODULE_3__/* .LabelS */ .ew, {
        color: color,
        $style: (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z)({}, _styles_utils__WEBPACK_IMPORTED_MODULE_6__/* .flexCenter */ ._7), {
            backgroundColor: backgroundColor,
            display: "inline-flex"
        }), (0,polished__WEBPACK_IMPORTED_MODULE_7__/* .padding */ .o3)("4px", "8px"), (0,_styles_utils__WEBPACK_IMPORTED_MODULE_6__/* .borderRadius */ .E0)(8)), {
            minWidth: "48px",
            whiteSpace: "nowrap"
        }),
        children: label
    });
});


/***/ }),

/***/ 40307:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "h": function() { return /* binding */ usePagination; }
/* harmony export */ });
/* harmony import */ var _swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(14924);
/* harmony import */ var _swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(26042);
/* harmony import */ var _swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(69396);
/* harmony import */ var next_dist_client_router__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(90387);
/* harmony import */ var next_dist_client_router__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(next_dist_client_router__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(67294);





var usePagination = function() {
    var limit = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : 10, pageName = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : "page";
    var router = (0,next_dist_client_router__WEBPACK_IMPORTED_MODULE_0__.useRouter)();
    var queryPage = (0,react__WEBPACK_IMPORTED_MODULE_1__.useMemo)(function() {
        return router.query[pageName] ? Number(router.query[pageName]) : Number(router.asPath.split("?".concat(pageName, "="))[1]);
    }, [
        pageName,
        router.asPath,
        router.query
    ]);
    var ref = (0,react__WEBPACK_IMPORTED_MODULE_1__.useState)(isNaN(queryPage) ? 1 : queryPage), page = ref[0], _setPage = ref[1];
    var setPage = (0,react__WEBPACK_IMPORTED_MODULE_1__.useCallback)(function(nextPage) {
        router.replace({
            pathname: router.pathname,
            query: (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)({}, router.query), (0,_swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)({}, pageName, nextPage))
        });
    }, [
        pageName,
        router
    ]);
    (0,react__WEBPACK_IMPORTED_MODULE_1__.useEffect)(function() {
        if (queryPage && queryPage !== page) {
            _setPage(queryPage);
        }
    }, [
        page,
        queryPage,
        setPage
    ]);
    var offset = (0,react__WEBPACK_IMPORTED_MODULE_1__.useMemo)(function() {
        return (page - 1) * limit;
    }, [
        limit,
        page
    ]);
    var ref1 = (0,react__WEBPACK_IMPORTED_MODULE_1__.useState)(0), countTotal = ref1[0], setCountTotal = ref1[1];
    var onPageChange = (0,react__WEBPACK_IMPORTED_MODULE_1__.useCallback)(function(param) {
        var nextPage = param.nextPage;
        setPage(nextPage);
    }, [
        setPage
    ]);
    var onPrevClick = (0,react__WEBPACK_IMPORTED_MODULE_1__.useCallback)(function() {
        if (page > 1) {
            setPage(page - 1);
        }
    }, [
        page,
        setPage
    ]);
    var onNextClick = (0,react__WEBPACK_IMPORTED_MODULE_1__.useCallback)(function() {
        if (page < Math.ceil(countTotal / limit)) {
            setPage(page + 1);
        }
    }, [
        countTotal,
        limit,
        page,
        setPage
    ]);
    var paginationProps = (0,react__WEBPACK_IMPORTED_MODULE_1__.useMemo)(function() {
        return {
            currentPage: page,
            numPages: Math.ceil(countTotal / limit),
            onPageChange: onPageChange,
            onNextClick: onNextClick,
            onPrevClick: onPrevClick
        };
    }, [
        countTotal,
        limit,
        onNextClick,
        onPageChange,
        onPrevClick,
        page
    ]);
    return {
        limit: limit,
        offset: offset,
        paginationProps: paginationProps,
        setCountTotal: setCountTotal,
        setPage: setPage,
        countTotal: countTotal
    };
};


/***/ }),

/***/ 32985:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "o_": function() { return /* binding */ remainingTime; },
/* harmony export */   "r8": function() { return /* binding */ dateFormatCurring; },
/* harmony export */   "vc": function() { return /* binding */ dateFormat; }
/* harmony export */ });
/* harmony import */ var date_fns__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(77349);
/* harmony import */ var date_fns_format__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(32912);
/* harmony import */ var date_fns_locale_ko__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(3006);
/* harmony import */ var _interval_to_duration_time__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(76476);




/**
 *
 * @param date
 * @param dateFormat default: 'yyyy-MM-dd HH:mm'
 * @returns
 */ var dateFormat = function(date) {
    var dateFormat = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : "yyyy.MM.dd HH:mm";
    if (!date) return undefined;
    return (0,date_fns_format__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)(new Date(date), dateFormat, {
        locale: date_fns_locale_ko__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z
    });
};
var remainingTime = function(date) {
    var amount = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : 1;
    if (!date) return undefined;
    var time = (0,_interval_to_duration_time__WEBPACK_IMPORTED_MODULE_2__/* .intervalTimeFromNow */ .s)({
        start: (0,date_fns__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)(new Date(date), amount)
    });
    return time;
};
var dateFormatCurring = function(formatText) {
    return function(date) {
        return dateFormat(date, formatText);
    };
};


/***/ }),

/***/ 67134:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "G": function() { return /* binding */ generatePath; }
/* harmony export */ });
/* harmony import */ var path_to_regexp__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(51068);

var cache = {};
var cacheLimit = 10000;
var cacheCount = 0;
function compilePath(path) {
    if (cache[path]) return cache[path];
    var generator = (0,path_to_regexp__WEBPACK_IMPORTED_MODULE_0__/* .compile */ .MY)(path);
    if (cacheCount < cacheLimit) {
        cache[path] = generator;
        cacheCount++;
    }
    return generator;
}
/**
 * Public API for generating a URL pathname from a path and parameters.
 */ var generatePath = function() {
    var path = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : "/", params = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {};
    return path === "/" ? path : compilePath(path)(params);
};


/***/ }),

/***/ 76476:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "s": function() { return /* binding */ intervalTimeFromNow; }
/* harmony export */ });
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var _components_base_block__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(94306);
/* harmony import */ var _styles_colors__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(32317);
/* harmony import */ var date_fns__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(61436);
/* harmony import */ var date_fns__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(98236);
/* harmony import */ var date_fns__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(42699);
/* harmony import */ var _date_format__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(32985);





var intervalTimeFromNow = function(param) {
    var start = param.start, _format = param.format, format = _format === void 0 ? "HH:mm:ss" : _format;
    if (!(0,date_fns__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)(start)) return;
    var now = new Date();
    var times = (0,date_fns__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)({
        start: start,
        end: now
    });
    var years = times.years, days = times.days, hours = times.hours, minutes = times.minutes, months = times.months, seconds = times.seconds;
    var time = (0,_date_format__WEBPACK_IMPORTED_MODULE_3__/* .dateFormat */ .vc)(new Date(years, months, days, hours, minutes, seconds), format);
    return (0,date_fns__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)(now, start) ? /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_components_base_block__WEBPACK_IMPORTED_MODULE_5__/* .BaseBlock */ .v, {
        as: "span",
        color: _styles_colors__WEBPACK_IMPORTED_MODULE_6__/* .colors.gray400 */ .O.gray400,
        children: "00:00:00"
    }) : /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_components_base_block__WEBPACK_IMPORTED_MODULE_5__/* .BaseBlock */ .v, {
        as: "span",
        color: hours < 4 ? _styles_colors__WEBPACK_IMPORTED_MODULE_6__/* .colors.red400 */ .O.red400 : _styles_colors__WEBPACK_IMPORTED_MODULE_6__/* .colors.gray700 */ .O.gray700,
        children: time
    });
};


/***/ }),

/***/ 20989:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "INQUIRIES_PAGE_LIMIT": function() { return /* binding */ INQUIRIES_PAGE_LIMIT; },
/* harmony export */   "__N_SSP": function() { return /* binding */ __N_SSP; }
/* harmony export */ });
/* harmony import */ var _swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_12__ = __webpack_require__(26042);
/* harmony import */ var _swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_11__ = __webpack_require__(69396);
/* harmony import */ var _swc_helpers_src_sliced_to_array_mjs__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(828);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var _apollo_client__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(6812);
/* harmony import */ var _components_layouts_settings_layout__WEBPACK_IMPORTED_MODULE_21__ = __webpack_require__(29339);
/* harmony import */ var _components_base_block__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(94306);
/* harmony import */ var _components_base_button__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(11485);
/* harmony import */ var _components_base_typography__WEBPACK_IMPORTED_MODULE_17__ = __webpack_require__(67408);
/* harmony import */ var _components_empty__WEBPACK_IMPORTED_MODULE_20__ = __webpack_require__(49774);
/* harmony import */ var _components_pagination__WEBPACK_IMPORTED_MODULE_19__ = __webpack_require__(34582);
/* harmony import */ var _components_tag_inquiry_status_tag__WEBPACK_IMPORTED_MODULE_16__ = __webpack_require__(92352);
/* harmony import */ var _lib_graphql_documents_generated__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(60369);
/* harmony import */ var _lib_hooks_use_pagination__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(40307);
/* harmony import */ var _lib_routes__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(78954);
/* harmony import */ var _lib_utils_date_format__WEBPACK_IMPORTED_MODULE_18__ = __webpack_require__(32985);
/* harmony import */ var _lib_utils_generate_path__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(67134);
/* harmony import */ var _styles_colors__WEBPACK_IMPORTED_MODULE_15__ = __webpack_require__(32317);
/* harmony import */ var _styles_utils__WEBPACK_IMPORTED_MODULE_14__ = __webpack_require__(45500);
/* harmony import */ var next_link__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(41664);
/* harmony import */ var next_link__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(next_link__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var polished__WEBPACK_IMPORTED_MODULE_13__ = __webpack_require__(43281);
/* harmony import */ var styletron_react__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(54511);






















var __N_SSP = true;
var INQUIRIES_PAGE_LIMIT = 12;
var InquiriesSettings = function(param) {
    var user = param.user;
    var ref = (0,_swc_helpers_src_sliced_to_array_mjs__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)((0,styletron_react__WEBPACK_IMPORTED_MODULE_3__/* .useStyletron */ .hQ)(), 1), css = ref[0];
    var ref1 = (0,_lib_hooks_use_pagination__WEBPACK_IMPORTED_MODULE_4__/* .usePagination */ .h)(INQUIRIES_PAGE_LIMIT), paginationProps = ref1.paginationProps, setCountTotal = ref1.setCountTotal, limit = ref1.limit, offset = ref1.offset;
    var data = (0,_apollo_client__WEBPACK_IMPORTED_MODULE_5__/* .useQuery */ .a)(_lib_graphql_documents_generated__WEBPACK_IMPORTED_MODULE_6__/* .GetInquiriesByOffsetDocument */ .Rv, {
        variables: {
            offset: offset,
            limit: limit,
            sortBy: _lib_graphql_documents_generated__WEBPACK_IMPORTED_MODULE_6__/* .InquirySortBy.CreatedAtDesc */ .jG.CreatedAtDesc,
            filter: {
                questionerId: user.id
            }
        },
        onCompleted: function(param) {
            var pageInfo = param.inquiries.pageInfo;
            if (pageInfo) {
                setCountTotal(pageInfo.countTotal);
            }
        }
    }).data;
    var inquiries = (data === null || data === void 0 ? void 0 : data.inquiries.edges) || [];
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(_components_base_block__WEBPACK_IMPORTED_MODULE_7__/* .BaseBlock */ .v, {
        children: [
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)((next_link__WEBPACK_IMPORTED_MODULE_1___default()), {
                href: _lib_routes__WEBPACK_IMPORTED_MODULE_8__/* .Routes.SUPPORT_INQUIRY_WRITE */ .Z.SUPPORT_INQUIRY_WRITE,
                passHref: true,
                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_components_base_button__WEBPACK_IMPORTED_MODULE_9__/* .BaseButton */ .Y, {
                    $size: "m",
                    $type: "tertiary",
                    leading: "Edit",
                    spaceBottom: 24,
                    children: "문의하기"
                })
            }),
            inquiries.map(function(param) {
                var _node = param.node, id = _node.id, createdAt = _node.createdAt, title = _node.title, answeredAt = _node.answeredAt;
                return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)((next_link__WEBPACK_IMPORTED_MODULE_1___default()), {
                    href: (0,_lib_utils_generate_path__WEBPACK_IMPORTED_MODULE_10__/* .generatePath */ .G)(_lib_routes__WEBPACK_IMPORTED_MODULE_8__/* .Routes.SETTINGS_INQUIRIES_DETAIL */ .Z.SETTINGS_INQUIRIES_DETAIL, {
                        id: id
                    }),
                    passHref: true,
                    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(_components_base_block__WEBPACK_IMPORTED_MODULE_7__/* .BaseBlock */ .v, {
                        flexbox: true,
                        as: "a",
                        cursor: "pointer",
                        alignItems: "center",
                        className: css((0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_11__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_12__/* ["default"] */ .Z)({}, (0,polished__WEBPACK_IMPORTED_MODULE_13__/* .padding */ .o3)("16px", "8px"), (0,_styles_utils__WEBPACK_IMPORTED_MODULE_14__/* .transition */ .eR)("background-color"), (0,_styles_utils__WEBPACK_IMPORTED_MODULE_14__/* .borderRadius */ .E0)(8)), {
                            columnGap: "16px",
                            ":hover": {
                                backgroundColor: _styles_colors__WEBPACK_IMPORTED_MODULE_15__/* .colors.gray50 */ .O.gray50
                            }
                        })),
                        children: [
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_components_tag_inquiry_status_tag__WEBPACK_IMPORTED_MODULE_16__/* .InquiryStatusTag */ .O, {
                                isAnswered: Boolean(answeredAt)
                            }),
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_components_base_typography__WEBPACK_IMPORTED_MODULE_17__/* .LabelM */ .i_, {
                                children: title
                            }),
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_components_base_typography__WEBPACK_IMPORTED_MODULE_17__/* .LabelXS */ .Ei, {
                                marginLeft: "auto",
                                color: _styles_colors__WEBPACK_IMPORTED_MODULE_15__/* .colors.gray500 */ .O.gray500,
                                children: (0,_lib_utils_date_format__WEBPACK_IMPORTED_MODULE_18__/* .dateFormat */ .vc)(createdAt, "yyyy.MM.dd")
                            })
                        ]
                    })
                }, id);
            }),
            inquiries.length > 0 ? /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_components_pagination__WEBPACK_IMPORTED_MODULE_19__/* .Pagination */ .t, (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_11__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_12__/* ["default"] */ .Z)({}, paginationProps), {
                className: css({
                    marginTop: "32px"
                })
            })) : /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_components_empty__WEBPACK_IMPORTED_MODULE_20__/* .EmptyList */ .r, {
                title: "1대1 문의 내역이 없습니다.",
                padding: "120px"
            })
        ]
    });
};
InquiriesSettings.getLayout = function(page) {
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_components_layouts_settings_layout__WEBPACK_IMPORTED_MODULE_21__/* .SettingsLayout */ .d, {
        helmetTitle: "1대1 문의 내역",
        children: page
    });
};
/* harmony default export */ __webpack_exports__["default"] = (InquiriesSettings);


/***/ })

}]);